import {
  Alert,
  AlertIcon,
  AlertDescription,
  AlertTitle,
  Text,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
} from '@chakra-ui/react';
import React from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';

import { MonacoType } from '../../../../../../types/global.d';
import { ConcentrationConfigVisualEditor } from './ConcentrationLimitEditor/ConcentrationConfigVisualEditor';
import { FormulaEditor } from './MonacoEditor/ui/FormulaEditor';

type ConcentrationLimitConfigDualEditorProps = {
  value: string;
  onChange: (value: string | undefined) => void;
  onValidate: (markers: MonacoType.editor.IMarker[]) => void;
  operationMode: CreditAgreement.OperationMode;
  availableFields: CreditAgreement.Config.ConcentrationLimit.Calculation.AvailableField[];
};
export const ConcentrationLimitConfigDualEditor = ({
  value,
  onChange,
  onValidate,
  operationMode,
  availableFields,
}: ConcentrationLimitConfigDualEditorProps) => {
  const parsedValue = React.useMemo(() => {
    try {
      return JSON.parse(
        value,
      ) as CreditAgreement.Config.ConcentrationLimit.SourceConfig;
    } catch (e) {
      return null;
    }
  }, [value]);

  if (parsedValue === null) {
    return (
      <Alert status="error" mb="20px" mt="20px">
        <AlertIcon />
        <AlertTitle>Errors</AlertTitle>
        <AlertDescription>
          <Text>Invalid JSON</Text>
        </AlertDescription>
      </Alert>
    );
  }
  return (
    <Tabs>
      <TabList>
        <Tab>Visual</Tab>
        <Tab>Json</Tab>
      </TabList>
      <TabPanels>
        <TabPanel>
          <ConcentrationConfigVisualEditor
            availableFields={availableFields}
            value={parsedValue}
            onChange={(newValue) => onChange(JSON.stringify(newValue, null, 2))}
          />
        </TabPanel>

        <TabPanel>
          <FormulaEditor
            language="json"
            value={value}
            onChange={onChange}
            onValidate={onValidate}
            operationMode={operationMode}
            resize="vertical"
            height="30vh"
          />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};
